import { UserData } from "../types/userTypes";
import { toast } from "sonner";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

export const exportUserData = (users: UserData[], format: 'csv' | 'excel' | 'pdf') => {
  if (!users.length) {
    toast.error("No data to export");
    return;
  }

  const exportData = users.map(user => ({
    Name: user.name,
    Role: user.role,
    'Created Date': format === 'csv' ? 
      new Date(user.createdAt).toISOString() : 
      new Date(user.createdAt).toLocaleDateString(),
    'Last Active': user.lastActive ? 
      (format === 'csv' ? 
        new Date(user.lastActive).toISOString() : 
        new Date(user.lastActive).toLocaleDateString()) : 
      'N/A',
    'Total Distance (km)': user.totalDistance
  }));

  switch (format) {
    case 'csv':
      const csvContent = [
        Object.keys(exportData[0]).join(','),
        ...exportData.map(row => Object.values(row).join(','))
      ].join('\n');
      
      const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const csvUrl = URL.createObjectURL(csvBlob);
      const csvLink = document.createElement('a');
      csvLink.href = csvUrl;
      csvLink.setAttribute('download', `users_export_${new Date().toISOString()}.csv`);
      document.body.appendChild(csvLink);
      csvLink.click();
      document.body.removeChild(csvLink);
      break;

    case 'excel':
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Users");
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const excelUrl = URL.createObjectURL(excelBlob);
      const excelLink = document.createElement('a');
      excelLink.href = excelUrl;
      excelLink.setAttribute('download', `users_export_${new Date().toISOString()}.xlsx`);
      document.body.appendChild(excelLink);
      excelLink.click();
      document.body.removeChild(excelLink);
      break;

    case 'pdf':
      const doc = new jsPDF();
      doc.text("User Export", 14, 14);
      autoTable(doc, {
        head: [Object.keys(exportData[0])],
        body: exportData.map(row => Object.values(row)),
        startY: 20,
      });
      doc.save(`users_export_${new Date().toISOString()}.pdf`);
      break;
  }

  toast.success(`Exporting users data as ${format.toUpperCase()}. File download will start shortly.`);
};
